import { Controller } from "@hotwired/stimulus"
import Quill from 'quill';
import 'quill/dist/quill.snow.css'

export default class extends Controller {
  static targets = ["textarea", "div", "input", "bodycount"]

  connect() {
    const toolbarOptions = [
      //見出し
      [{
        'header': [1, 2, 3, 4, 5, 6, false]
      }],
      //フォント種類
      [{
        'font': []
      }],
      //文字寄せ
      [{
        'align': []
      }],
      //太字、斜め、アンダーバー
      ['bold', 'italic', 'underline'],
      // リスト
      [{
          'list': 'ordered'
        },
        {
          'list': 'bullet'
        }
      ],
      //インデント
      [{
        'indent': '-1'
      }, {
        'indent': '+1'
      }],
      //画像挿入
      ['image'],
      //動画
      ['video'],
      //数式
      ['formula'],
      //URLリンク
      ['link']
    ];
    const quill = new Quill(this.divTarget, {
      modules: {
        //ツールバーの設定
        toolbar: toolbarOptions
      },
      placeholder: '本文を入力..',
      theme: 'snow',
    });

    quill.on('text-change', () => {
      const content = quill.root.innerHTML;
      this.textareaTarget.value = content
      // this.textareaTarget.value = content.replace(/<\/?[^>]+(>|$)/g, '');
      // this.bodycountTarget.value = this.textareaTarget.value.length;
      // this.updateCount(this.textareaTarget.value)
    });
  }

  // updateCount(textarea) {
  //   let totalCharacters = this.inputTargets.reduce((sum, input) => {
  //     return sum + input.value.length;
  //   }, 0);
  //   this.bodycountTarget.textContent = `Total characters: ${totalCharacters}`;
  // };

}
